import React, { useState, useEffect } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import {
  fetchCustomerType,
  fetchFactoryType,
  fetchSerialNumberType,
} from '../../_redux/_actions/scopedMenuAction'
import { history } from '../../_redux/_store/history'
import queryString from 'query-string'
import { useDispatch, useSelector } from 'react-redux'
import Grid from '@material-ui/core/Grid'
import Autocomplete from '@material-ui/lab/Autocomplete'
import TextField from '@material-ui/core/TextField'
import { selectAnomalyRulePageSelect } from "../../_redux/_actions/selectScopedAnomalyRuleAction";
const useStyles = makeStyles((theme) => ({
  Colon: {
    padding: '3px',
    marginTop: '20px',
    textAlign:'center'
  },
  ScopeMenu: {
    width: 200,
    margin: '5px',
  },
}))

export default function SelectScopeMenu({ getScopeData, selectScopedPage, createScopedAnomalyRule }) {
  const classes = useStyles()
  const [customerType, setCustomerType] = useState([])
  const [selectedCustomerType, setSelectedCustomerType] = useState('')
  const [factoryType, setFactoryType] = useState([])
  const [selectedFactoryType, setselectedFactoryType] = useState('')
  const [serialNumberType, setserialNumberType] = useState([])
  const [selectedSerialNumberType, setSelectedSerialNumberType] = useState('')
  const [scopeArrayData, setScopeArrayData] = useState(new Array(4))
  const selectAnomalyRulePageResponse = useSelector((state) => state.selectScopedAnomalyRule)
  const queryValues = queryString.parse(history.location.search)
  const {machine_type, hmi_type} = queryValues
  const dispatch = useDispatch()

  const menuDataResponse = useSelector((state) => state.selectMenuData)
  const filterDataResponse = useSelector((state) => state.detailsPersist)

  useEffect(() => {
    async function getScopeList() {
      dispatch(fetchCustomerType(machine_type, hmi_type))
    }
    getScopeList()
    if (filterDataResponse.filterData) {
      // if (filterDataResponse.filterData[0]) {
      //   handleMachineChange(filterDataResponse.filterData[0])
      // }
      if (filterDataResponse.filterData[1]) {
        handleCustomerChange(filterDataResponse.filterData[1])
      }
      if (filterDataResponse.filterData[2]) {
        handleFactoryChange(filterDataResponse.filterData[2])
      }
      if (filterDataResponse.filterData[3]) {
        handleSerialNumberChange(filterDataResponse.filterData[3])
      }
    }
  }, [])

  useEffect(() => {
      if (selectAnomalyRulePageResponse.selectAnomalyRulePage && selectAnomalyRulePageResponse.specificAnomalyRule ) {
        scopeArrayData[0] = selectAnomalyRulePageResponse.specificAnomalyRule[0].signals[0].machine_type
        dispatch(
          selectAnomalyRulePageSelect()
        );
        scopeArrayData[0] = selectAnomalyRulePageResponse.specificAnomalyRule[0].signals[0].machine_type
        getScopeData(scopeArrayData.join(''))
      }
  }, [selectAnomalyRulePageResponse.selectAnomalyRulePage,selectAnomalyRulePageResponse.specificAnomalyRule])

  useEffect(() => {
    if (menuDataResponse.selectCustomerTypes) {
      setCustomerType(menuDataResponse.selectCustomerTypes)
    }
    if (menuDataResponse.selectFactoryTypes) {
      setFactoryType(menuDataResponse.selectFactoryTypes)
    }
    if (menuDataResponse.selectSerialNumberTypes) {
      setserialNumberType(menuDataResponse.selectSerialNumberTypes)
    }
  }, [menuDataResponse])

  const handleCustomerChange = (event) => {
    setSelectedCustomerType(event)
    setselectedFactoryType('')
    setSelectedSerialNumberType('')
    scopeArrayData[2] = ''
    scopeArrayData[3] = ''
    if (event) {
      dispatch(fetchFactoryType(event,machine_type, hmi_type))
      scopeArrayData[1] = event
    } else {
      scopeArrayData[1] = ''
    }
    setScopeArrayData(scopeArrayData)
    getScopeData(scopeArrayData.join(''))
  }

  const handleFactoryChange = (event) => {
    setselectedFactoryType(event)
    setSelectedSerialNumberType('')
    if (event) {
      dispatch(fetchSerialNumberType(machine_type, hmi_type,selectedCustomerType, event))
      scopeArrayData[2] = ':' + event
    } else {
      scopeArrayData[2] = ''
    }
    scopeArrayData[3] = ''
    setScopeArrayData(scopeArrayData)
    getScopeData(scopeArrayData.join(''))
  }

  const handleSerialNumberChange = (event) => {
    setSelectedSerialNumberType(event)
    if (event) {
      scopeArrayData[3] = ':' + event
    } else {
      scopeArrayData[3] = ''
    }
    setScopeArrayData(scopeArrayData)
    getScopeData(scopeArrayData.join(''))
  }

  return (
    <>
      <Grid item >
        <Autocomplete
          id='customer-Type'
          options={customerType}
          value={selectedCustomerType}
          onChange={(event, newValue) => {
            handleCustomerChange(newValue)
          }}
          className={classes.ScopeMenu}
          renderInput={(params) => (
            <TextField
              {...params}
              label='Customer'
              variant='outlined'
            />
          )}
        />
      </Grid>
      <Grid item className={classes.Colon} >
        :
      </Grid>
      <Grid item >
        <Autocomplete
          id='factory-Type'
          options={factoryType}
          onChange={(event, newValue) => {
            handleFactoryChange(newValue)
          }}
          value={selectedFactoryType}
          disabled={scopeArrayData[1] || selectedCustomerType ? null : true}
          className={classes.ScopeMenu}
          renderInput={(params) => (
            <TextField
              {...params}
              label='Factory'
              variant='outlined'
            />
          )}
        />
      </Grid>
      <Grid item className={classes.Colon} >
        :
      </Grid>
      <Grid item >
        <Autocomplete
          id='serial-Number-Type'
          options={serialNumberType}
          value={selectedSerialNumberType}
          disabled={scopeArrayData[3] || selectedFactoryType ? null : true}
          onChange={(event, newValue) => {
            handleSerialNumberChange(newValue)
          }}
          className={classes.ScopeMenu}
          renderInput={(params) => (
            <TextField
              {...params}
              label='Serial Number'
              variant='outlined'
            />
          )}
        />
      </Grid>
    </>
  )
}
